import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cs-carousel" }
const _hoisted_2 = { class: "container cs-carousel-container" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-chevron-left" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-chevron-right" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "cs-carousel-content-wrapper" }

import { ref, onMounted, onUnmounted, computed } from "vue";
import ScrollBooster from "./scrollbooster";

const scrollDistance = 400;


export default /*#__PURE__*/_defineComponent({
  __name: 'cs-carousel',
  setup(__props) {

const viewport = ref<HTMLElement | null>(null);
const content = ref<HTMLElement | null>(null);
const scrollBooster = ref<ScrollBooster | null>(null);
const lastX = ref(0);
const scrollPositionX = ref(0);
const canBack = ref(true);
const canNext = ref(true);
const touching = ref(false);
const ontouchstart = () => {
  touching.value = true;
  scrollBooster.value?.destroy();
  scrollBooster.value = null;
};

const ontouchend = () => {
  touching.value = false;
  if (!scrollBooster.value) {
    const left = viewport.value?.scrollLeft || 0;
    scrollBooster.value = new ScrollBooster({
      viewport: viewport.value as HTMLElement,
      content: content.value as HTMLElement,
      scrollMode: "native",
      direction: "horizontal",
      onUpdate: (state) => {
        const { x } = state.position;
        const diff = Math.abs(x - lastX.value);
        if (diff !== 0 && diff < 0.05 && scrollBooster.value) {
          scrollBooster.value.isTargetScroll = false;
          scrollBooster.value.velocity = { x: 0, y: 0 };
        }
        lastX.value = x;
      },
    } as any);
    scrollBooster.value.setPosition({ x: left, y: 0 });
  }
};

const onscroll = () => {
  if (scrollBooster.value && scrollBooster.value.position) {
    const boosterX = -scrollBooster.value.position.x;
    const viewportX = viewport.value?.scrollLeft || 0;

    if (Math.abs(viewportX - boosterX) > 1) {
      scrollBooster.value.isTargetScroll = false;
    }
  }
  scrollPositionX.value = viewport.value?.scrollLeft || 0;
  canBack.value = scrollPositionX.value > 10;
  canNext.value =
    (viewport.value?.scrollWidth || 0) - (viewport.value?.clientWidth || 0) - 10 >
    scrollPositionX.value;
};

const onmousedown = () => {
  if (scrollBooster.value) {
    scrollBooster.value.isTargetScroll = false;
  }
};

const next = () => {
  scrollBooster.value?.scrollTo({
    x: (viewport.value?.scrollLeft || 0) + scrollDistance,
    y: 0,
  });
};

const prev = () => {
  scrollBooster.value?.scrollTo({
    x: (viewport.value?.scrollLeft || 0) - scrollDistance,
    y: 0,
  });
};

onMounted(() => {
  ontouchend();
  onscroll();
});

onUnmounted(() => {
  scrollBooster.value?.destroy();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        "aria-label": "previous",
        onClick: prev,
        disabled: !canBack.value,
        class: "cs-carousel-button cs-carousel-button-prev btn-link",
        type: "button"
      }, _hoisted_5, 8, _hoisted_3),
      _createElementVNode("button", {
        "aria-label": "next",
        onClick: next,
        disabled: !canNext.value,
        class: "cs-carousel-button cs-carousel-button-next btn-link",
        type: "button"
      }, _hoisted_8, 8, _hoisted_6)
    ]),
    _createElementVNode("div", {
      class: "cs-carousel-viewport",
      ref_key: "viewport",
      ref: viewport,
      onScrollPassive: _cache[3] || (_cache[3] = ($event: any) => (onscroll()))
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "cs-carousel-content",
          ref_key: "content",
          ref: content,
          onMousedown: _cache[0] || (_cache[0] = ($event: any) => (onmousedown())),
          onTouchstart: _cache[1] || (_cache[1] = ($event: any) => (ontouchstart())),
          onTouchend: _cache[2] || (_cache[2] = ($event: any) => (ontouchend()))
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 544)
      ])
    ], 544)
  ]))
}
}

})